import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';
import ProductNew from './ProductNew';
import ProductOld from './ProductOld';

const Product = ({
  sectionHeadings,
  productDetails,
  productSteps,
  retailers,
  breadcrumb,
  currentBreakpoint,
  categoryTitle,
  subcategoryTitle,
  productSwatch,
  shapes,
  videos,
  shouldUseBazaar,
  customRetailer,
  currentUrl,
  tracking,
  hidePrice,
  selectedSKU,
  vto,
  channelAdvisorWidget,
  customHeroes,
}) => (
  <>
    {R.path(['new_design'], productDetails) && (
      <ProductNew
        sectionHeadings={sectionHeadings}
        productDetails={productDetails}
        productSteps={productSteps}
        retailers={retailers}
        breadcrumb={breadcrumb}
        currentBreakpoint={currentBreakpoint}
        categoryTitle={categoryTitle}
        subcategoryTitle={subcategoryTitle}
        productSwatch={productSwatch}
        shapes={shapes}
        videos={videos}
        shouldUseBazaar={shouldUseBazaar}
        customRetailer={customRetailer}
        currentUrl={currentUrl}
        tracking={tracking}
        hidePrice={hidePrice}
        selectedSKU={selectedSKU}
        vto={vto}
        channelAdvisorWidget={channelAdvisorWidget}
        customHeroes={customHeroes}
      />
    )}
    {!R.path(['new_design'], productDetails) && (
      <ProductOld
        sectionHeadings={sectionHeadings}
        productDetails={productDetails}
        productSteps={productSteps}
        retailers={retailers}
        breadcrumb={breadcrumb}
        currentBreakpoint={currentBreakpoint}
        categoryTitle={categoryTitle}
        subcategoryTitle={subcategoryTitle}
        productSwatch={productSwatch}
        videos={videos}
        shouldUseBazaar={shouldUseBazaar}
        customRetailer={customRetailer}
        currentUrl={currentUrl}
        tracking={tracking}
        hidePrice={hidePrice}
        selectedSKU={selectedSKU}
        vto={vto}
        channelAdvisorWidget={channelAdvisorWidget}
        customHeroes={customHeroes}
      />
    )}
  </>
);

Product.propTypes = {
  channelAdvisorWidget: PropTypes.element,
  productDetails: PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    shadeSelectLabel: PropTypes.string.isRequired,
    noReviewsLabel: PropTypes.string.isRequired,
    readReviewsLabel: PropTypes.string.isRequired,
    showMoreRetailersLabel: PropTypes.string.isRequired,
    showLessRetailersLabel: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    tabs: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        content: PropTypes.string.isRequired,
      })
    ),
  }),
  productSteps: PropTypes.shape({
    imageSrc: PropTypes.string,
    imageSrcSet: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        src: PropTypes.string,
      })
    ),
  }),
  retailers: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      price: PropTypes.string,
      currency: PropTypes.string,
    })
  ),
  sectionHeadings: PropTypes.shape({
    relatedProducts: PropTypes.shape({
      heading: PropTypes.string,
    }),
    productSteps: PropTypes.shape({
      heading: PropTypes.string,
    }),
    retailers: PropTypes.shape({
      heading: PropTypes.string,
    }),
  }),
  breadcrumb: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      label: PropTypes.string.isRequired,
    })
  ),
  currentBreakpoint: PropTypes.string.isRequired,
  categoryTitle: PropTypes.string,
  subcategoryTitle: PropTypes.string,
  productSwatch: PropTypes.shape({
    swatches: PropTypes.arrayOf(
      PropTypes.shape({
        sku: PropTypes.string,
        itemName: PropTypes.string,
        skuColor: PropTypes.string,
      })
    ),
  }),
  shapes: PropTypes.shape({
    shape: PropTypes.arrayOf(
      PropTypes.shape({
        sku: PropTypes.string,
        title: PropTypes.string,
        code: PropTypes.string,
      })
    ),
  }),
  videos: PropTypes.objectOf(PropTypes.object),
  shouldUseBazaar: PropTypes.bool,
  customRetailer: PropTypes.shape({
    title: PropTypes.string,
    button: PropTypes.shape({
      title: PropTypes.string,
      link: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
    retailer: PropTypes.shape({
      name: PropTypes.string.isRequired,
      currencyCode: PropTypes.string,
      currency: PropTypes.string,
    }),
  }),
  currentUrl: PropTypes.string.isRequired,
  tracking: PropTypes.shape({
    currencyCode: PropTypes.string,
    product: PropTypes.arrayOf(
      PropTypes.shape({
        attributes: PropTypes.shape({
          productUrl: PropTypes.string,
        }),
      })
    ),
  }),
  hidePrice: PropTypes.bool,
  selectedSKU: PropTypes.string,
  vto: PropTypes.instanceOf(PropTypes.object),
  customHeroes: PropTypes.instanceOf(PropTypes.object),
};

export default connect(({ content, breakpoints, status, productSwatch }) => ({
  productDetails: R.prop('productDetails', content),
  productSteps: R.prop('productSteps', content),
  retailers: R.prop('retailers', content),
  sectionHeadings: R.prop('sectionHeadings', content),
  breadcrumb: R.prop('breadcrumb', content),
  currentBreakpoint: R.prop('current', breakpoints),
  categoryTitle: R.prop('categoryTitle')(content),
  subcategoryTitle: R.prop('subcategoryTitle')(content),
  productSwatch: R.prop('productSwatch')(content),
  shapes: R.prop('shapes')(content),
  videos: R.prop('videos', content),
  shouldUseBazaar: R.prop('shouldUseBazaar')(content),
  customRetailer: R.prop('customRetailer')(content),
  currentUrl: R.prop('currentUrl', status),
  tracking: R.prop('tracking')(content),
  hidePrice: R.prop('hidePrice', content),
  selectedSKU: R.prop('selectedSKU', productSwatch),
  vto: R.prop('vto', content),
  channelAdvisorWidget: R.prop('channelAdvisorWidget', content),
  customHeroes: R.prop('customHeroes', content),
}))(Product);
